/* A product-level cart indicator from the confirmed cart, never an optimistic add.
   Watch the existing drawer renderer rather than intercepting cart requests. */
(function () {
  'use strict';
  if (window.__evCollectionCartStatus) return;
  window.__evCollectionCartStatus = true;
  let running = false;
  let pending = false;
  let revision = 0;

  function paint(items) {
    const ids = new Set(items.filter(item => item.quantity > 0).map(item => String(item.product_id)));
    document.querySelectorAll('[data-card-cart-status]').forEach(mark => {
      mark.hidden = !ids.has(mark.closest('[data-product-id]')?.dataset.productId);
    });
  }

  async function refresh() {
    revision += 1;
    if (running) { pending = true; return; }
    running = true;
    do {
      pending = false;
      const requestRevision = revision;
      try {
        const root = window.Shopify?.routes?.root || window.theme?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        if (requestRevision === revision) paint(cart.items);
      } catch (_) {
        if (requestRevision === revision) paint([]);
      }
    } while (pending);
    running = false;
  }

  document.addEventListener('ev:commerce', event => {
    if (event.detail?.name === 'add_to_cart_success') refresh();
  });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.querySelectorAll('cart-drawer [data-cart-body], cart-page [data-cart-body], [data-rv-list]').forEach(body => {
    new MutationObserver(refresh).observe(body, { childList: true, subtree: true });
  });
  refresh();
})();
